module.exports = __webpack_public_path__ + "img/activation-email-flow.ea80f7ba.png";